<script setup lang="ts">
import { BSnackbar, BOnboardingModal } from '@/design-system';
import { RouterView } from 'vue-router';
import BConfirmDialog from './design-system/components/patterns/BConfirmDialog.vue';
import { useOnboardingStore } from '@/stores/onboardingStore';
import {
    useTranslation, useGlobalShortcuts, useDocumentTitle,
} from '@/composables';

const onboardingStore = useOnboardingStore();
const { t } = useTranslation();

const init = () => {
    useGlobalShortcuts();
    useDocumentTitle();
};

init();
</script>

<template>
    <BSnackbar />
    <BConfirmDialog />
    <BOnboardingModal
        v-if="onboardingStore.currentConfig"
        v-model="onboardingStore.isOpen"
        :storage-key="onboardingStore.currentConfig.storageKey"
        :title="t(onboardingStore.currentConfig.title)"
        :success-message="t(onboardingStore.currentConfig.successMessage)"
        :next-step-message="t(onboardingStore.currentConfig.nextStepMessage)"
        :action-label="
            onboardingStore.currentConfig.actionLabel ? t(onboardingStore.currentConfig.actionLabel) : undefined
        "
        :show-action="onboardingStore.currentConfig.showAction ?? true"
        @action="onboardingStore.handleAction"
        @close="onboardingStore.close"
    />
    <VApp>
        <RouterView />
    </VApp>
</template>
